import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import ContentSection from '../components/ContentSection';
import Footer from '../components/Footer';
import CTA from "../components/CTA";
import ParentsHIIT from "../assets/images/parent-with-kids.png";
import '../styles/App.css';


function FAQs() {
  const generalFAQ = {
	sectionTitle: (
	  <>
		Frequently Asked <span style={{ color: 'red' }}>Questions</span>
	  </>
	),
	sectionDescription: 'Below you’ll find some FAQs from coaches, athletes, and parents.',
	items: [
	  {
		title: 'What is Functional Training?',
		body1: (
		  <>
			<p>Functional training focuses on building strength, endurance, mobility, and coordination through movements that mimic real-life activities. It is designed to enhance athletic performance and reduce injury risk.</p>
		  </>
		),
	  },
	  {
		title: 'How is Functional Strength Different from Weight Training?',
		body1: (
		  <>
			<p>Traditional weight training often isolates muscles, while functional strength training incorporates multiple muscle groups working together. It prioritizes movement patterns essential for sports performance and daily activities.</p>
		  </>
		),
	  },
	  {
		title: 'Our Coaching Philosophy',
		body1: (
		  <>
			<p>We believe in an athlete-first approach, prioritizing proper movement mechanics, injury prevention, and long-term development over short-term gains. Our goal is to build stronger, more resilient athletes.</p>
		  </>
		),
	  },
	  {
		title: 'How Do I Sign Up for a Membership?',
		body1: (
		  <>
			<p>We are currently collecting emails and information of interested coaches, families, and individuals. Scroll to the bottom of this page to submit your information. </p>
		  </>
		),
	  },
	],
  };

  const coachFAQ = {
	sectionTitle: <> Coach <span style={{ color: 'red' }}>FAQs</span> </>,
	sectionDescription: 'Details for coaches looking to train athletes at our facility.',
	items: [
	  {
		title: 'How Can Coaches Rent Space?',
		body1: (
		  <>
			<p>Coaches will be able to book facility space for individual or team training sessions. We will offer flexible scheduling options and an online calendar management tool for coaches to schedule time.</p>
		  </>
		),
	  },
	  {
		title: 'What Training Equipment is Available?',
		body1: (
		  <>
			<p>Our facility includes weightlifting platforms, benches, weight racks, kettle bells, medicine balls, dumbells, and barbells. We also have plymetric spaces and equipment including box jumps, rubber bands, sprint ladders, hurdles, and a variety of foam rollers for recovery and activation.</p>
		  </>
		),
	  },
	  {
		title: 'Are There Certifications Required to Coach Here?',
		body1: (
		  <>
			<p>Coaches of youth athletes must hold a current SafeSport certfication. Other sport specific certfications by governing bodies are suggested but not required. Examples: USA Track & Field, USA Volleyball, USA Basketball, USA Triathlon, et cetera.</p>
		  </>
		),
	  },
	  {
		title: 'How Do I Become a Founding Coach?',
		body1: (
		  <>
			<p>We are looking for passionate, skilled coaches to join our facility. Founding coaches receive special benefits, including prioritized training hours. Are you interested in becoming a Founding Coach? Sign-up below.</p>
		  </>
		),
	  },
	],
  };
  
  return (
	<div className="home">
	  <SEO
		title="Frequently Asked Questions"
		description="Got questions about functional training, coaching, memberships, or our facility? Find answers to the most common questions here."
		image="/social-media-image.png"
		path="/faqs"
	  />
	  <Header />
	  <main>
		{/* Full Section with Title and Description */}
		<ContentSection
		  sectionTitle={generalFAQ.sectionTitle}
		  sectionDescription={generalFAQ.sectionDescription}
		  items={generalFAQ.items}
		  sectionClass="faq-section"
		  spacer={true}
		/>

		{/* Additional Section with another title and description */}
		<ContentSection
		  sectionTitle={coachFAQ.sectionTitle}
		  sectionDescription={coachFAQ.sectionDescription}
		  items={coachFAQ.items}
		  sectionClass="faq-sub-section"
		/>
		<CTA
		title={
			<>
			  Parents <span style={{ color: 'red' }}>& Kids</span>
			</>
		  }
		  description={
			<>
			  <p>
				Are you a parent looking for a space to work out with your child? Our Family Package is designed for families with 1–4 kids who want to train, build skills on the court, or move together on the turf.
			  </p>
			  <p>
				A family that trains together, wins together.
			  </p>
			</>
		  }
		  imageSrc={ParentsHIIT}
		  primaryButtonText="Send Info"
		  primaryButtonLink="#"
		/>
		<Footer />
	  </main>
	</div>
  );
}

export default FAQs;